/* Copyright 2013 - 2024 Waiterio LLC */

const context = import.meta.webpackContext('./pages', {
  recursive: true,
  regExp: /\.\/(?!.*\.test\.(js|jsx)$).*\.(js|jsx)$/,
})

export default context
